module.exports = __webpack_public_path__ + "media/images/consumer/components/progress-bar/step-05-58f48320258b982d08fdc616439c2dee.webp";